export default function GetErroredRows(mergeData, erroredLines, setErroredRows){
    let erroredData = [];
    mergeData.forEach(row=>{
        if(erroredLines.includes(row)){
            erroredData.push(row);
        }
    });
    setErroredRows(erroredData);
}